// extracted by mini-css-extract-plugin
export default {"textLeft":"styles_textLeft__G7cvn","pieWrapper":"styles_pieWrapper__fFUuL","selectPediodSelection":"styles_selectPediodSelection__peLMV","nenhumDado":"styles_nenhumDado__eVrG3"};